import { Fade, Flex, Image } from '@chakra-ui/react';
import { ImageDisclaimerType } from '@llx/common';

import { getAssetUrl } from '@/utils/createAssetUrl';

type Props = {
  disclaimer: ImageDisclaimerType;
  casePath: string;
};

function ImageDisclaimer({ disclaimer, casePath }: Props) {
  return (
    <Flex height="100%" justifyContent="center" alignItems="center" w="full" bgColor="black">
      <Fade in>
        <Image
          objectFit="fill"
          key={disclaimer.url}
          alt="logo"
          src={getAssetUrl(casePath, disclaimer.url)}
        />
      </Fade>
    </Flex>
  );
}

export default ImageDisclaimer;
